import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/leis-auth.scss'

const Contrato = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchContratos()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    
    const setVer = async (id) => {
        props.ver(id)
    }

    const setSituacao = async (id) => {
        props.situacao(id)
    }
    const setAditivo = async (id) => {
        props.aditivo(id)
    }

    var ano;
    props.contrato.ano ? ano = props.contrato.ano : ano = props.contrato.anoProcesso;

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Contrato Nº {props.contrato.numero} do {props.contrato.modalidade} Processo Nº{props.contrato.processo}/{ano}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.contrato._id)} variant='primary'>Editar</Button>
                    <Button type="button" className="botao-leis" onClick={() => setVer(props.contrato._id)} variant='primary'>Ver Contrato</Button>
                    <Button type="button" className="botao-leis" onClick={() => setSituacao(props.contrato._id)} variant='primary'>Atualizar Situação</Button>
                    <Button type='button' className="botao-leis" onClick={() => setAditivo(props.contrato._id)} variant='primary'>Anexar Termo Aditivo</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.contrato._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Contrato;